import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useRedirectAfterNewSave = (basepath: string, id?: number) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (id) {
            const nextLocation = basepath.replace(':id', id.toString());
            if (!location.pathname.includes(nextLocation)) {
                navigate(nextLocation, { replace: true });
            }
        }
    }, [basepath, id, navigate, location]);
};
